import { render, staticRenderFns } from "./supportDesk.vue?vue&type=template&id=eeab26c4&scoped=true&"
import script from "./supportDesk.vue?vue&type=script&lang=js&"
export * from "./supportDesk.vue?vue&type=script&lang=js&"
import style0 from "./supportDesk.vue?vue&type=style&index=0&id=eeab26c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeab26c4",
  null
  
)

export default component.exports